import React from "react";
import Constants from "../../../configurations/constants";
import Formsy from "formsy-react";
import { DiscoverFields } from "../../../configurations/discoverConfigs/fields";
import TextInput from "../common/controls/TextInput";
import FormSelect from "../common/controls/Select";
import DatePickerWrapper from "../common/controls/DatePicker";
import { Permissioned } from "react-permissions";
import { connect } from "react-redux";
import Permissions from "../../../configurations/permissions";
import Util from "../../../util/util";

class DiscoverCaseSearch extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      createdStartDate: null,
      createdEndDate: null,
      expiryStartDate: null,
      expiryEndDate: null
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onCreatedFromDateChange = this.onCreatedFromDateChange.bind(this);
    this.onCreatedToDateChange = this.onCreatedToDateChange.bind(this);
    this.onExpiredFromDateChange = this.onExpiredFromDateChange.bind(this);
    this.onExpiredToDateChange = this.onExpiredToDateChange.bind(this);
  }

  onCreatedFromDateChange(date) {
    this.createdStartDate.props.setValue(
      date && date.startOf("day").format(Constants.DATE_FORMAT_LONG)
    );
    this.setState({
      createdStartDate: date && date.startOf("day")
    });
  }

  onCreatedToDateChange(date) {
    this.createdEndDate.props.setValue(
      date && date.endOf("day").format(Constants.DATE_FORMAT_LONG)
    );
    this.setState({
      createdEndDate: date && date.endOf("day")
    });
  }

  onExpiredFromDateChange(date) {
    this.expiryStartDate.props.setValue(
      date && date.startOf("day").format(Constants.DATE_FORMAT_LONG)
    );
    this.setState({
      expiryStartDate: date && date.startOf("day")
    });
  }

  onExpiredToDateChange(date) {
    this.expiryEndDate.props.setValue(
      date && date.endOf("day").format(Constants.DATE_FORMAT_LONG)
    );
    this.setState({
      expiryEndDate: date && date.endOf("day")
    });
  }

  handleSubmit(data) {
    this.props.onSearchHandler(data, true);
  }

  render() {
    const {
      createdStartDate,
      createdEndDate,
      expiryStartDate,
      expiryEndDate
    } = this.state;
    return (
      <Formsy
        onValidSubmit={this.handleSubmit}
        ref="discoverCaseFilter"
        noValidate
      >
        <div className="row">
          <div className="col-sm-10">
            <div className="row">
              <div className="col-md-4">
                <TextInput
                  name={DiscoverFields.caseNumber.name}
                  label={DiscoverFields.caseNumber.label}
                />
              </div>
              <div className="col-md-4">
                <FormSelect
                  name="noticeType"
                  label={DiscoverFields.noticeTypeCode.label}
                  options={DiscoverFields.noticeTypeCode.fieldValues}
                  valueKey="value"
                  labelKey="description"
                />
              </div>
              <div className="col-md-4">
                <TextInput name="issuerCode" label="Issuer Code" />
              </div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <DatePickerWrapper
                  name="createdStartDate"
                  dateFormat={Constants.DATE_FORMAT}
                  label="Created Date (From)"
                  maxDate={createdEndDate || 0}
                  disabledKeyboardNavigation={true}
                  peekNextMonth={true}
                  showMonthDropdown={true}
                  showYearDropdown={true}
                  readOnly={true}
                  innerRef={c => {
                    this.createdStartDate = c;
                  }}
                  onChange={this.onCreatedFromDateChange}
                  dropdownMode="select"
                  selected={createdStartDate}
                />
              </div>
              <div className="col-md-3">
                <DatePickerWrapper
                  name="createdEndDate"
                  dateFormat={Constants.DATE_FORMAT}
                  label="Created Date (To)"
                  disabledKeyboardNavigation={true}
                  peekNextMonth={true}
                  showMonthDropdown={true}
                  showYearDropdown={true}
                  readOnly={true}
                  innerRef={c => {
                    this.createdEndDate = c;
                  }}
                  onChange={this.onCreatedToDateChange}
                  dropdownMode="select"
                  selected={createdEndDate}
                  minDate={createdStartDate}
                  maxDate={0}
                />
              </div>
              <div className="col-md-3">
                <DatePickerWrapper
                  name="expiryStartDate"
                  dateFormat={Constants.DATE_FORMAT}
                  label="Expiry Date (From)"
                  disabledKeyboardNavigation={true}
                  peekNextMonth={true}
                  showMonthDropdown={true}
                  showYearDropdown={true}
                  readOnly={true}
                  dropdownMode="select"
                  innerRef={c => {
                    this.expiryStartDate = c;
                  }}
                  onChange={this.onExpiredFromDateChange}
                  selected={expiryStartDate}
                  maxDate={expiryEndDate}
                />
              </div>
              <div className="col-md-3">
                <DatePickerWrapper
                  name="expiryEndDate"
                  dateFormat={Constants.DATE_FORMAT}
                  label="Expiry Date (To)"
                  disabledKeyboardNavigation={true}
                  peekNextMonth={true}
                  showMonthDropdown={true}
                  showYearDropdown={true}
                  readOnly={true}
                  dropdownMode="select"
                  innerRef={c => {
                    this.expiryEndDate = c;
                  }}
                  onChange={this.onExpiredToDateChange}
                  selected={expiryEndDate}
                  minDate={expiryStartDate}
                />
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <button className="btn btn-primary btn-block mt-20" type="submit">
              Search
            </button>
          </div>
        </div>
      </Formsy>
    );
  }
}

export default connect(Util.defaultMapStateToProps)(
  Permissioned(DiscoverCaseSearch, [Permissions.VIEW_DISPUTE])
);



// WEBPACK FOOTER //
// ./src/components/discover/cases/DiscoverCaseSearch.js